function _0x1828(_0x119609, _0x644f55) {
  const _0x29750a = _0x2975();
  return (
    (_0x1828 = function (_0x18289c, _0x3aded9) {
      _0x18289c = _0x18289c - 0x160;
      let _0x2099e9 = _0x29750a[_0x18289c];
      return _0x2099e9;
    }),
    _0x1828(_0x119609, _0x644f55)
  );
}
function _0x2975() {
  const _0x239f1e = [
    "innerHTML",
    "product-recommendations--full",
    "4sCbGkD",
    "text",
    "169503aiHZuR",
    "add",
    "fetchProducts",
    "product-recommendations--loaded",
    "contains",
    "580509dfRprd",
    "20zvNnlS",
    "then",
    "17712ZNMerJ",
    "trim",
    "div",
    "closest",
    "3438256zFDEBi",
    "createElement",
    "dataset",
    "469fLajRv",
    "connectedCallback",
    "define",
    "length",
    "935466nNkfgA",
    "2034654ypyaJc",
    "active",
    "product-recommendations",
    "classList",
    "866425exeTBq",
    "open-cart",
    "body",
    "parent",
  ];
  _0x2975 = function () {
    return _0x239f1e;
  };
  return _0x2975();
}
const _0x46e0e0 = _0x1828;
(function (_0x3dc371, _0x46d8c6) {
  const _0x4b16e9 = _0x1828,
    _0x4b8db7 = _0x3dc371();
  while (!![]) {
    try {
      const _0x3a63b8 =
        -parseInt(_0x4b16e9(0x163)) / 0x1 +
        -parseInt(_0x4b16e9(0x176)) / 0x2 +
        parseInt(_0x4b16e9(0x177)) / 0x3 +
        (-parseInt(_0x4b16e9(0x161)) / 0x4) * (parseInt(_0x4b16e9(0x17b)) / 0x5) +
        (parseInt(_0x4b16e9(0x16b)) / 0x6) * (parseInt(_0x4b16e9(0x172)) / 0x7) +
        parseInt(_0x4b16e9(0x16f)) / 0x8 +
        (parseInt(_0x4b16e9(0x168)) / 0x9) * (-parseInt(_0x4b16e9(0x169)) / 0xa);
      if (_0x3a63b8 === _0x46d8c6) break;
      else _0x4b8db7["push"](_0x4b8db7["shift"]());
    } catch (_0x4cfffa) {
      _0x4b8db7["push"](_0x4b8db7["shift"]());
    }
  }
})(_0x2975, 0x596b5);
class ProductRecommendations extends HTMLElement {
  constructor() {
    const _0x39cde5 = _0x1828;
    super(), (this[_0x39cde5(0x17e)] = this[_0x39cde5(0x16e)](".product-recommendations--parent"));
  }
  [_0x46e0e0(0x165)]() {
    const _0x37664b = _0x46e0e0;
    fetch(this[_0x37664b(0x171)]["url"])
      [_0x37664b(0x16a)]((_0x128284) => _0x128284[_0x37664b(0x162)]())
      [_0x37664b(0x16a)]((_0x580a04) => {
        const _0x270364 = _0x37664b,
          _0x5c1d10 = document[_0x270364(0x170)](_0x270364(0x16d));
        _0x5c1d10["innerHTML"] = _0x580a04;
        const _0x4fcc11 = _0x5c1d10["querySelector"](_0x270364(0x179));
        _0x4fcc11 &&
          _0x4fcc11[_0x270364(0x17f)][_0x270364(0x16c)]()[_0x270364(0x175)] &&
          ((this[_0x270364(0x17f)] = _0x4fcc11[_0x270364(0x17f)]),
          this[_0x270364(0x17e)] &&
            (this[_0x270364(0x17e)][_0x270364(0x17a)][_0x270364(0x164)](_0x270364(0x160)),
            document[_0x270364(0x17d)]["classList"][_0x270364(0x167)](_0x270364(0x17c)) &&
              this["parent"][_0x270364(0x17a)][_0x270364(0x164)](_0x270364(0x178)))),
          this[_0x270364(0x17a)]["add"](_0x270364(0x166));
      })
      ["catch"]((_0x777245) => {
        console["error"](_0x777245);
      });
  }
  [_0x46e0e0(0x173)]() {
    const _0x371099 = _0x46e0e0;
    this[_0x371099(0x165)]();
  }
}
customElements[_0x46e0e0(0x174)](_0x46e0e0(0x179), ProductRecommendations);
